import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { FeedbackComponent } from './components/feedback/feedback.component';
import { HipaaConsentAuthorizationComponent } from './components/hipaa-consent-authorization/hipaa-consent-authorization.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './components/terms-of-service/terms-of-service.component';
import { TermsOfTelemedicineComponent } from './components/terms-of-telemedicine/terms-of-telemedicine.component';
import { TermsOfUseComponent } from './components/terms-of-use/terms-of-use.component';
import { TeliHealthComponent } from './components/teli-health/teli-health.component';
import { UnifiedPrivacyPolicyComponent } from './components/unified-privacy-policy/unified-privacy-policy.component';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  // { path: 'home', component: HomeComponent },
  { path: 'contact-us', component: ContactUsComponent },
  { path: 'foot-hipaaConsentAuthorization', component: HipaaConsentAuthorizationComponent },
  { path: 'foot-privacy-policy', component: PrivacyPolicyComponent },
  { path: 'foot-unifiedprivacy-policy', component: UnifiedPrivacyPolicyComponent },
  { path: 'foot-terms-of-service', component: TermsOfServiceComponent },
  { path: 'foot-terms-of-use', component: TermsOfUseComponent },
  { path: 'foot-terms-of-telemedicine', component: TermsOfTelemedicineComponent },
  { path: 'feedback', component: FeedbackComponent },
  { path: 'teleHealth', component: TeliHealthComponent },
  {
    path: '',
    loadChildren: () => import('./visor/visor.module').then(module => module.VisorModule)
  },
  // {
  //   path: 'patientPortal',
  //   loadChildren: () => import('./patient-portal/patient-portal.module').then(module => module.PatientPortalModule)
  // },
  {
    path: 'carejourney',
    loadChildren: () => import('./care-journey/care-journey.module').then(module => module.CareJourneyModule)
  },
  { path: '**', redirectTo: 'login' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
